import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/{-$locale}/email-link_/')({
  loader: () => {
    throw notFound();
  }
});
